import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "../i18n/LanguageContext";
import { BRAND, waLink, GOOGLE_BUSINESS_URL, GOOGLE_REVIEW_URL } from "../config";
import { WhatsAppIcon, GoogleIcon, InstagramIcon } from "./icons";

export const Footer = () => {
  const { t } = useLang();

  const googleClick = (e) => {
    if (!GOOGLE_REVIEW_URL && !GOOGLE_BUSINESS_URL) {
      e.preventDefault();
      toast(t.common.soonGoogle, { icon: "✳" });
    }
  };

  return (
    <footer className="bg-mauve text-cream" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/assets/logo-mark.png" alt="Bloom Beauty Concept Hair" className="w-14 h-14 rounded-full" />
              <div>
                <p className="font-serif text-2xl font-semibold tracking-wide">Bloom Beauty</p>
                <p className="text-[10px] uppercase tracking-[0.34em] text-cream/70">Concept Hair</p>
              </div>
            </div>
            <p className="mt-6 max-w-sm font-serif text-xl italic leading-relaxed text-cream/90">
              “{t.footer.tagline}”
            </p>
            <div className="mt-7 flex items-center gap-3">
              <a
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-cream transition-all duration-300 hover:bg-gold hover:border-gold hover:text-ink"
              >
                <InstagramIcon className="w-[18px] h-[18px]" />
              </a>
              <a
                href={waLink(t.waDefault)}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-cream transition-all duration-300 hover:bg-gold hover:border-gold hover:text-ink"
              >
                <WhatsAppIcon className="w-[18px] h-[18px]" />
              </a>
              <a
                href={GOOGLE_BUSINESS_URL || "#"}
                onClick={googleClick}
                aria-label="Google"
                data-testid="footer-google"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-cream transition-all duration-300 hover:bg-gold hover:border-gold hover:text-ink"
              >
                <GoogleIcon className="w-[18px] h-[18px]" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-cream/60">{t.footer.nav}</p>
            <ul className="mt-5 space-y-3 text-[15px]">
              {[
                ["/", t.nav.home, "footer-nav-home"],
                ["/sobre", t.nav.about, "footer-nav-about"],
                ["/servicos", t.nav.services, "footer-nav-services"],
                ["/transformacoes", t.nav.transformations, "footer-nav-transformations"],
                ["/galeria", t.nav.gallery, "footer-nav-gallery"],
                ["/contato", t.nav.contact, "footer-nav-contact"],
                ["/privacidade", t.footer.privacy, "footer-nav-privacy"],
              ].map(([to, label, id]) => (
                <li key={to}>
                  <Link to={to} data-testid={id} className="text-cream/85 transition-colors hover:text-white hover:underline hover:decoration-gold hover:underline-offset-4">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-cream/60">{t.footer.contact}</p>
            <address className="mt-5 not-italic text-[15px] leading-relaxed text-cream/85">
              {BRAND.addressLines.map((l) => (
                <span key={l} className="block">{l}</span>
              ))}
            </address>
            <a href={`tel:+${BRAND.phoneIntl}`} data-testid="footer-phone" className="mt-4 block text-[15px] text-cream/85 hover:text-white">
              {BRAND.phoneDisplay}
            </a>
            <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" className="mt-1 block text-[15px] text-cream/85 hover:text-white">
              {BRAND.instagram}
            </a>
            <p className="mt-4 text-sm text-cream/60">{t.footer.hours}</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream/15 pt-7 text-[12px] tracking-wide text-cream/60 sm:flex-row">
          <p>© {new Date().getFullYear()} {BRAND.name}. {t.footer.rights}</p>
          <p className="font-script text-xl text-cream/80">floresce a sua beleza</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
